import { Alert, CircularProgress } from '@mui/material';
import AlertIcon from '@assets/icons/alertas.svg';
import './index.css';
import { useEffect, useState } from 'react';

interface UserStatusAlertProps {
  onSetInactive?: () => void;
  onSetActive?: () => void;
  visible?: boolean;
}

const UserStatusAlert: React.FC<UserStatusAlertProps> = ({
  onSetInactive,
  onSetActive,
  visible = false,
}) => {
  const [loading, setLoading] = useState<'inactive' | 'active' | null>(null);

  const handleClick = (type: 'inactive' | 'active') => {
    try {
      if (type === 'inactive' && onSetInactive) {
        onSetInactive();
      } else if (type === 'active' && onSetActive) {
        onSetActive();
      }
    } catch (error) {
      console.error('Error al cambiar el estado del usuario:', error);
    } finally {
      setLoading(null);
    }
  };

  useEffect(() => {
    if (visible) {
      setLoading(null);
    }
  }, [visible]);

  if (!visible) return null;

  return (
    <Alert
      severity="warning"
      className="userStatusMessage"
      icon={
        <img src={AlertIcon} alt="Alerta" className="userStatusMessageIcon" />
      }
    >
      <div>
        <strong className="userStatusMessageTitle_title">
          No olvides actualizar tu estado
        </strong>
        <p className="userStatusMessageTitle_description">
          Estás en modo almuerzo/break o cerrando turno. Si ya volviste,
          actualiza tu estado para no perder casos o si ya terminaste, cámbialo
          a inactivo.
        </p>
        <div className="userStatusMessage_buttons">
          <button
            className="userStatusMessage_button"
            onClick={() => {
              handleClick('inactive');
              setLoading('inactive');
            }}
            disabled={loading === 'active'}
          >
            {loading === 'inactive' ? (
              <CircularProgress size={20} />
            ) : (
              'Cambiar a inactivo'
            )}
          </button>
          <button
            className="userStatusMessage_button"
            onClick={() => {
              handleClick('active');
              setLoading('active');
            }}
            disabled={loading === 'inactive'}
          >
            {loading === 'active' ? (
              <CircularProgress size={20} />
            ) : (
              'Volver a activo'
            )}
          </button>
        </div>
      </div>
    </Alert>
  );
};

export default UserStatusAlert;
